import React from 'react';
import './index.sass';

const NotFound = () => {
    return (
        <div className="page page-not-found">
            <div className="page-content">
                <div className="container text-center">
                    <div className="display-1 text-muted mb-5">
                        <i className="si si-exclamation"/> 404
                    </div>
                    <h1 className="h2 mb-3">
                        Oops.. Página não encontrada
                    </h1>
                    <p className="h4 text-muted font-weight-normal mb-7">
                        O recurso que você solicitou não existe ou pode não estar mais disponível.{" "}
                    </p>
                    <a className="btn btn-primary" href="javascript:history.back()">
                        <i className="fe fe-arrow-left mr-2"/>Go back
                    </a>
                </div>
            </div>
        </div>
    );
};

export default NotFound;